import request from '@/utils/request'
import qs from 'qs'
// 登录

export function loginaction(query) {
  return request.post("data/api.login/login", query);
}
// 注册

export function register(query) {
  return request.post("data/api.login/register", query);
}
// 认证
export function login_cert(query) {
  return request.post("data/api.login/cert", query);
}
// 获取用户信息
export function user_info(query) {
  return request.post("data/api.login/info", query);
}
// 头像上传
export function login_header(query) {
  return request.post("api/LandPoint/headimg", query);
}
// 图片上传
export function login_photo(query) {
  return request.post("api/LandPoint/upload", query);
}
// 修改密码
export function edtpassword(query) {
  return request.post("data/api.login/password", query);
}
// 积分规则
export function getRule(query) {
  return request.post("data/api.data/getRule", query);
}
// 积分明细
export function integralin(query) {
  return request.post("data/api.user/integralin", query);
}
// 积分兑换
export function integralout(query) {
  return request.post("data/api.user/integralout", query);
}
// 获取文化程度
export function culture(query) {
  return request.post("data/api.data/culture", query);
}
// 获取证书列表
export function certificate(query) {
  return request.post("data/api.user/certificate", query);
}
// 获取证书列表
export function cert_detail(query) {
  return request.post("data/api.user/cert_detail", query);
}


// WEBPACK FOOTER //
// ./src/api/user.js